// extracted by mini-css-extract-plugin
export default {"features-pricing-container":"Home_features-pricing-container__TCSbz"};